<template>
  <div class="ui stackable grid">
      <div class="sixteen wide column" v-if="items && items.length == 0">
        <div class="ui placeholder segment">
          <div class="ui icon header">
            <i class="camera retro icon big"></i>
            Looks like you don't have any stuff added yet!
          </div>
          <router-link to="/capture" class="item narrow">
            <div class="ui primary button">Add Stuff</div>
          </router-link>
        </div>
      </div>
      <div class="sixteen wide column" v-if="items.length > 0">

      <h1 class="ui header">
        Your Stuff
        <div class="sub header">({{filteredItems.length}} items @ ${{totalValue}})</div>
      </h1>

      <div class="ui form">
        <div class="fields">
          <div class="field">
            <label>Search Item Names</label>
            <div class="ui corner labeled input">
              <input type="text" placeholder="Search..." v-model="searchText">
              <div class="ui corner label" @click="searchText=''">
                <i v-bind:class="{'icon':true, 'info': searchText=='', 'x': searchText!=''}"></i>
              </div>
            </div>
          </div>
          <div class="field">
            <label>Filter Tags</label>
            <div class="ui labels">
              <a v-for="(tag, index) in tags" @click="toggleTag(tag)" :key="index" v-bind:class="{ 'ui': true, 'label': true, 'big': true, 'grey': !tag.enabled, 'green': tag.enabled }">
                <span v-if="!showArchive">{{tag.name}}</span><span v-if="showArchive">{{tag.archivedVariant}}</span>
              </a>
              <a @click="toggleTagless()" v-bind:class="{ 'ui': true, 'narrow': true, 'big': true, 'label': true, 'grey': !showTagless, 'green': showTagless }"><i class="icon eye slash outline"></i></a>
            </div>
          </div>
          <div class="field">
            <label>Layout</label>
            <a @click="toggleLayout()" v-bind:class="{ 'ui narrow label compact big': true, 'grey': !tableLayout, 'green': tableLayout }">
              <i :class="{'icon th': true, 'list': tableLayout }"></i></a>
          </div>
          <!-- <div class="field">
            <label>Fix Items...</label>
            <a @click="fixItems()" v-bind:class="{ 'ui': true, 'narrow': true, 'label': true, 'compact': true, 'big': true }">
              <i :class="{'icon wrench': true }"></i>
            </a>
          </div> -->
          <div class="field">
            <label>Archive</label>
            <!-- <label v-if="!showArchive">Open archive...</label>
            <label v-if="showArchive">Close archive...</label> -->
            <div class="ui labels">
              <a @click="toggleArchive()" v-bind:class="{ 'ui label big compact narrow': true, 'grey': !showArchive, 'green': showArchive }"><i :class="{'folder icon': true, 'open': !showArchive}"></i></a>
            </div>
          </div>
          <div class="field">
            <label>Order</label>
            <!-- <label v-if="orderAsc">Order Asc...</label> -->
            <!-- <label v-if="!orderAsc">Order Desc...</label> -->
            <div class="ui input">
              <a @click="toggleOrder()" for="sort" class="ui narrow label compact big grey"><i v-bind:class="{'icon sort amount': true, 'down': !orderAsc, 'up': orderAsc}"></i></a>
            </div>
          </div>
          <div class="field">
            &nbsp;
          </div>
          <!-- <div class="ui fields">
            <div class="sixteen field wide">
              <label>Galleries</label>
              <select v-model="selectedGallery" class="ui dropdown">
                <option value="-1">-- select --</option>
                <option v-for="(curGallery, index) in galleries" :key="index" :value="curGallery">{{curGallery.name}}</option>
              </select>
            </div>
            <div class="four field wide">
              <label><br/></label>
              <a @click="saveGallery()" v-bind:class="{ 'ui narrow label compact big': true, 'grey': selectedItems.length == 0, 'green': selectedItems.length != 0 }" :disabled="selectedItems.length == 0">Save</a>
            </div>
          </div> -->
        </div>
      </div>

      <div v-if="!items" class="ui active centered inline loader"></div>
        <div v-if="items">
        <table v-if="tableLayout" id="items-table" class="ui celled striped table table-responsive">
          <thead>
            <tr>
              <th class="two wide">
                Photo
              </th>
              <th class="four wide">
                Name
              </th>
              <th class="four wide">
                Tags
              </th>
              <th class="two wide">
                Value
              </th>
              <th class="four wide">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item) in filteredItems" :key="item.id" :class="{'reversed': !orderAsc}">
              <td>
                <img class="ui tiny image" :src="item.data">
                <!-- <img v-if="!item.data.includes('jpg')" class="ui tiny image" :src="'https://storage.cloud.google.com/our-assets.appspot.com/images/'+item.data+'_290x290.jpeg'"> -->
              </td>
              <td>
                <div class="ui corner labeled input">
                  <input type="text" v-model="item.name" @focus="soil(item)" />
                  <div class="ui corner label">
                    <i class="info icon"></i>
                  </div>
                </div>
              </td>
              <td>
                <div class="ui labels">
                  <a v-for="(tag, index) in tags" :key="index" @click="setTag(item, tag)" v-bind:class="{ 'ui': true, 'label': true, 'grey': !item.tags.includes(tag.name), 'green': item.tags.includes(tag.name) }"><span v-if="!showArchive">{{tag.name}}</span><span v-if="showArchive">{{tag.archivedVariant}}</span></a>
                </div>
              </td>
              <td>
                <div class="ui corner labeled input">
                  <input type="text" v-model="item.value" @focus="soil(item)" />
                  <div class="ui corner label">
                    <i class="dollar icon"></i>
                  </div>
                </div>
              </td>
              <td>
                <button v-bind:class="{'ui': true, 'narrow': true, 'button': true, 'orange': item.dirty}" @click="save(item)"><i title="save" class="save icon"></i></button>
                <router-link :to="{ name: 'Item', 'params': {id: item.id}}" class="ui button"><i class="edit icon"></i></router-link>
                <button class="ui button" v-if="selectedGallery != '-1' && !item.inGallery" @click="addToGallery(item)" title="Add to Gallery">
                  <i class="plus circle icon"></i>
                </button>
                <button class="ui button" v-if="selectedGallery != '-1' && item.inGallery" @click="removeFromGallery(item)" title="Remove from Gallery">
                  <i class="minus circle icon"></i>
                </button>
                <button class="ui button" @click="archiveItem(item)"><i title="archive" :class="{'folder icon': true, 'open': !showArchive}"></i></button>
                <button v-if="showArchive" class="ui bottom attached button" @click="deleteItem(item)"><i :class="{'trash icon': true}"></i></button>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="!tableLayout" :class="{'ui link four doubling cards': true, 'reversed': !orderAsc}">
          <div class="card" v-for="(item, index) in filteredItems" :key="index">
            <!-- <div class="ui fluid image" @click="selectItem(item)"> -->
            <div class="ui fluid image">
              <!-- <a class="ui green circular label"><i class="icon check circle"></i></a> -->
              <div v-bind:class="{ 'ui ribbon label': true, 'green': !item.inGallery && item.selected, 'red': item.inGallery && item.selected}" v-if="item.selected || item.inGallery">
                <i v-bind:class="{'circle icon': true, 'minus': item.inGallery && item.selected, 'plus': !item.inGallery && item.selected, 'check': item.inGallery && !item.selected}"></i> In Gallery
              </div>
              <!-- <div v-bind:class="{ 'ui ribbon label': true}" v-if="item.selected || item.inGallery">
                <i v-bind:class="{'circle icon': true, 'plus': !item.inGallery && item.selected, 'check': !item.selected || item.inGallery}"></i>
              </div> -->
              <a class="ui card_price tag green label">${{item.value}}</a>
              <img :src="item.data">
            </div>
            <div class="content">
              <div class="header">{{item.name}}</div>
              <div class="meta">
                <div class="ui labels">
                  <a v-for="(tag, index) in tags" :key="index" @click="setTag(item, tag)" v-bind:class="{ 'ui': true, 'label': true, 'grey': !item.tags.includes(tag.name), 'green': item.tags.includes(tag.name) }">
                    <span v-if="!showArchive">{{tag.name}}</span><span v-if="showArchive">{{tag.archivedVariant}}</span>
                  </a>
                </div>
              </div>
              <div class="description">
                {{item.description}}
              </div>
            </div>
            <router-link :to="{ name: 'Item', 'params': {id: item.id}}" class="ui bottom attached button">
              <i class="edit icon"></i>
              Edit Item
            </router-link>
            <div class="ui bottom attached button" v-if="selectedGallery != -1 && !item.inGallery" @click="addToGallery(item)">
              <i class="plus circle icon"></i>
              Add to Gallery
            </div>
            <div class="ui bottom attached button" v-if="selectedGallery != -1 && item.inGallery" @click="removeFromGallery(item)">
              <i class="minus circle icon"></i>
              Remove from Gallery
            </div>
            <div class="ui bottom attached button" @click="archiveItem(item)">
              <i :class="{'folder icon': true, 'open': showArchive}"></i> <span v-if="!showArchive">Archive</span><span v-if="showArchive">Unarchive</span>
            </div>
            <div v-if="showArchive" class="ui bottom attached button" @click="deleteItem(item)">
              <i :class="{'trash icon': true}"></i> Delete
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-if="selectedItems.length > 0" class="four column centered row item_count">
      <div class="ui image label blue">
        {{selectedItems.length}} Items Selected
        <i class="delete icon" @click="clearSelected"></i>
      </div>
    </div> -->
    <a class="ui label massive back_to_top" href="#iapp">
      <i class="icon arrow circle up" style="margin: 0;"></i>
    </a>
    <div class="ui mini modal">
      <i class="close icon"></i>
      <div class="header">
          {{modalHeader}}
      </div>
      <div class="content">
        <div class="ui form">
          <div class="field twelve wide">
            {{modalMessage}}
          </div>
          <div class="field">
            <label></label><br />
            <div class="ui fluid input">
              <div class="ui primary button" @click="doModalAction">
                Confirm
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Items',
  components: {
  },
    data() {
        return {
          searchText: "",
          tags: [
            {name: 'sell', archivedVariant: 'sold', enabled: false, color: 'blue'},
            {name: 'keep', archivedVariant: 'kept', enabled: false, color: 'green'},
            {name: 'donate', archivedVariant: 'donated', enabled: false, color: 'red'}
          ],
          showTagless: false,
          showArchive: localStorage.showArchive == 'true',
          tableLayout: localStorage.tableLayout == 'true',
          selectedGallery: "-1",
          orderAsc: localStorage.orderAsc == 'true',
          modalHeader: "",
          modalMessage: "",
          modalAction: async function() {}
        }
    },
    mounted() {
    },
    computed: {
      totalValue: function() {
        var value = 0
        if (this.filteredItems && this.filteredItems.length) {
          for (var i = 0; i < this.filteredItems.length; i++) {
            if (!isNaN(this.filteredItems[i].value)) {
              value += Number(this.filteredItems[i].value)
            }
          }
        }

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      mainAccount: function() {
        if (this.accounts.length == 0) {
          return {id: this.user.uid, default_account: this.user.uid, users: []}
        }
        return this.accounts.filter(account => account.id == this.user.uid)[0]
      },
      filteredItems: function() {
        function sortAsc(a,b) {
          var output = 0
          if (a.created_at.seconds < b.created_at.seconds) {
            output = -1
          } else if (a.created_at.seconds > b.created_at.seconds) {
            output = 1
          }
          return output
        }
        function sortDesc(a,b) {
          var output = 0
          if (a.created_at > b.created_at) {
            output = -1
          } else if (a.created_at < b.created_at) {
            output = 1
          }
          return output
        }
        var items = !this.showArchive?this.items:this.archivedItems

        var enabledTags = this.tags.filter(tag => tag.enabled)

        items = items.filter(item => item.created_by == this.mainAccount.default_account && !item.deleted)

        if (this.searchText !== "" || enabledTags.length > 0) {
          items = items.filter(item => item.name && item.name.toLowerCase().includes(this.searchText.toLowerCase()))
        }

        if (enabledTags.length > 0) {
          items = items.filter(item => enabledTags.some(tag => item.tags.includes(tag.name)))
        }
        else if (this.showTagless) {
          items = items.filter(item => item.tags.length == 0)
        }

        // if (this.selectedGallery != "-1") {
        //   var gallery = this.galleries.find(gallery => gallery.id == this.selectedGallery.id)
        //   for (var i = 0; i < items.length; i++) {
        //     var curItem = items[i]
        //     if (gallery.items.find(itemId => itemId == curItem.id)) {
        //       curItem.inGallery = true
        //     } else {
        //       curItem.inGallery = false
        //     }
        //   }
        // } else {
        //   for (var j = 0; j < items.length; j++) {
        //     items[j].inGallery = false
        //   }
        // }

        if (this.orderAsc) {         
          items.sort(sortAsc)
        } else {
          items.sort(sortDesc)
        }

        return items
      },
      // selectedItems: function() {
      //   return this.filteredItems.filter(item => item.selected)
      // },
      ...mapGetters({
        user: 'getUser',
        items: 'ItemModule/get',
        archivedItems: 'ItemModule/getArchived',
        accounts: 'AccountModule/get',
        // galleries: 'GalleryModule/get'
      })
    },
    methods: {
      // inSelectedGallery: function(curItem) {
      //   return this.selectedGallery.items.find(id => curItem.id == id)
      // },
      archiveItem: async function(curItem) {
        if (!curItem.archived) {
          await this.doConfirm("Archive Item", `Are you sure you want to archive ${curItem.name}?`, async function(store) {
            await store.dispatch('ItemModule/archive', curItem)
            window.jQuery('.ui.modal').modal('hide')
          })
        } else {
            this.$store.dispatch('ItemModule/archive', curItem)
        }
      },
      deleteItem: async function(curItem) {
        await this.doConfirm("Delete Item", `Are you sure you want to delete ${curItem.name}?`, async function(store) {
          await store.dispatch('ItemModule/permadelete', curItem)
          window.jQuery('.ui.modal').modal('hide')
        })
      },
      save: function(curItem) {
        curItem.dirty = false
        this.$store.dispatch('ItemModule/save', curItem)
      },
      fixItems: async function() {
        // console.log(this.items.length, this.archivedItems.length)

        // var curItem = null
        // for (var i = 0; i < this.items.length; i++) {
        //   curItem = this.items[i]
        //   // await this.$store.dispatch('ItemModule/save', curItem)
        //   console.log(curItem.deleted)
        // }

        // for (var j = 0; j < this.archivedItems.length; j++) {
        //   curItem = this.archivedItems[j]
        //   await this.$store.dispatch('ItemModule/save', curItem)
        //   console.log(curItem)
        // }
      },
      selectItem: function(item) {
        item.selected = !item.selected;
      },
      toggleTag: function(curTag) {
        this.showTagless = false
        curTag.enabled = !curTag.enabled;
      },
      toggleLayout: function() {
        this.tableLayout = !this.tableLayout
        localStorage.setItem('tableLayout', this.tableLayout)
      },
      toggleArchive: function() {
        this.showArchive = !this.showArchive
        localStorage.setItem('showArchive', this.showArchive)
      },
      toggleOrder: function() {
        this.orderAsc = !this.orderAsc
        localStorage.setItem('orderAsc', this.orderAsc)
      },
      toggleTagless: function() {
        if (!this.showTagless) {
          this.tags.forEach(tag => tag.enabled = false)
        }
        this.showTagless = !this.showTagless
      },
      setTag: function(curItem, tag) {
        if (!curItem.tags) {
          curItem.tags = [tag.name]
        }
        else {
          var index = curItem.tags.indexOf(tag.name);
          if (index > -1) {
            curItem.tags.splice(index, 1);
          } else {
            curItem.tags.push(tag.name);
          }
        }

        this.$store.dispatch('ItemModule/setTags', curItem)
      },
      addToGallery: function(item) {
        if (this.selectedGallery !== "-1") {
          this.$store.dispatch('GalleryModule/addToGallery', {itemId: item.id, gallery: this.selectedGallery})
          item.inGallery = true
        }
      },
      removeFromGallery: function(item) {
        if (this.selectedGallery !== "-1") {
          this.$store.dispatch('GalleryModule/removeFromGallery', {itemId: item.id, gallery: this.selectedGallery})
          item.inGallery = false
        }
      },
      // saveGallery: async function() {
      //   if (this.selectedGalleryId !== "-1") {

      //     const updateIds = this.selectedItems.map(item => item.id)
      //     await this.$store.dispatch('GalleryModule/saveItems', {itemIds: updateIds, galleryId: this.selectedGalleryId})
      //   }
      //   this.clearSelected()
      // },
      clearSelected: function() {
        this.items.forEach(item => item.selected = false)
      },
      soil: function(curItem) {
        curItem.dirty = true;
      },
      doModalAction: async function() {
        this.modalAction(this.$store)
      },
      doConfirm: async function(header, message, action) {
        this.modalHeader = header
        this.modalMessage = message
        this.modalAction = action
        window.jQuery('.ui.modal').modal('show')
      }
    }
}
</script>

<style scoped>
body {
  overflow-y: auto !important
}
.ui.placeholder .image:not(.header):not(.ui) {
  height: auto;
}

.item_count {
  position: fixed !important;
  bottom: 0px;
  z-index: 6;
  text-align: center;
  left: 50%;
  transform: translate(-50%, 0);
}

.back_to_top {
  position: fixed;
  right: 0px;
  bottom: 0px;
  z-index: 7;
}
#take-photo {text-align: center; margin:0 auto; transform: translateY(-75px);}
#take-photo button {margin-right: 15px;}
.ui.button>i.icon {margin: 0 !important;}
div.image>a.card_price {position: absolute; right: 4px; bottom: 7px;}
.ui.form div.fields>div.field {margin-bottom: 15px;}
div.meta>div.labels {margin-top: 15px;}

.ui.table.table-responsive {margin-top:30px;width:100%;background-color:#fff;border:1px solid #eee;box-shadow:0 2px 2px #c7c7c7}
.ui.table.table-responsive td,.ui.table.table-responsive th{padding:10px 20px}
.ui.table.table-responsive td:first-child,.ui.table.table-responsive th:first-child{text-align:left}
.ui.table.table-responsive th{border-bottom:2px solid #c7c7c7;text-align:center}
.ui.table.table-responsive th img{max-height:20px}

table img{margin:5px 0;max-width:200px}

/* .card .image .circular.label {
  position: absolute;
  top: 10px;
  left: 10px;
  color: #fff;
  display: bfolder;
  background: #21ba45;
  border-radius: 100%;
} */

/* .card .image .circular.label i {
  margin: 0;
} */

@media only screen and (max-width:995px){
  .ui.table.table-responsive td,.ui.table.table-responsive th{padding:10px 5px}
  .ui.table.table-responsive img{max-width:100px}
}

@media (min-device-width:760px) and (max-device-width:1024px),only screen and (max-width:760px){
  .ui.table.table-responsive{display:bfolder;background:transparent;border:none;box-shadow:none}
  .ui.table.table-responsive tbody,.ui.table.table-responsive td,.ui.table.table-responsive th,.ui.table.table-responsive thead,.ui.table.table-responsive tr{display:bfolder}
  .ui.table.table-responsive thead tr{position:absolute;top:-9999px;left:-9999px}
  .ui.table.table-responsive td:first-child{vertical-align:middle;}
  .ui.table.table-responsive td{border-bottom:1px solid #eee;position:relative;padding-left:25% !important;background:#fff}
  .ui.table.table-responsive td:before{position:absolute;top:50%;left:26px;width:20%;padding-right:10px;white-space:nowrap;transform:translateY(-50%);text-align:left}
}

@media only screen and (max-width:760px){
  .ui.grid>.ui.container>.ui.grid {padding: 0 1rem;}
  .ui.table.table-responsive td,.ui.table.table-responsive th{padding:10px 5px}
  .ui.table.table-responsive img{max-width:200px}

  #items-table td:before {
    font-weight: bold;
  }

  #items-table td:nth-of-type(1):before {
      content: "Photo";
      white-space: normal;
  }

  #items-table td:nth-of-type(2):before {
      content: "Name";
      white-space: normal;
  }

  #items-table td:nth-of-type(3):before {
      content: "Value";
      white-space: normal;
  }

  #items-table td:nth-of-type(4):before {
      content: "Actions";
      white-space: normal;
  }

  .card .image img:before {
    content: ' ';
    display: bfolder;
    position: absolute;
    height: 50px;
    width: 50px;
    background-image: url(https://via.placeholder.com/260x150);
  }
}
</style>
